import HCGMReport from './components/HCGMReport.vue'
import HCGMReportPrepare from './components/HCGMReportPrepare.vue'
import LoginReport from './components/LoginReport.vue'
import ReportList from './components/ReportList.vue'
import ReportHeader from './components/ReportHeader.vue'
import UserTypeSelect from './components/UserTypeSelect.vue'
import UploadMachineCode from './components/UploadMachineCode.vue'


let paths = '/path';

//路由实现
const routes = [{
        path: '/',
        redirect: '/select'
    },
    {
        path: '/select',
        component: UserTypeSelect
    },
    {
        path: '/login',
        components: {
            default: LoginReport,
        }
    },

    {
        path: '/reportList',
        components: {
            default: ReportList,
            header: ReportHeader,
            // footer:ReportFooter,
        }
    },

    {
        path: '/report1',
        components: {
            default: HCGMReport,
        }
    },
    {
        path: '/reportPrepare',
        components: {
            header: ReportHeader,
            default: HCGMReportPrepare,
        }
    },
    {
        path: '/UploadMachine',
        components: {
            header: ReportHeader,
            default: UploadMachineCode,
            // footer: ReportFooter,
        }
    },

];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js